import { useEffect, useState, useContext } from "react";
import { BASELINE } from "../../util";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import ModalComponent from "../dashboard/pick_modal";
import { FaCheckCircle, FaTimesCircle, FaBookmark, FaMinus } from "react-icons/fa";
import { FaAnglesRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

const Hero = ({ testData, free }) => {
  const { user } = useContext(UserContext);
  const [percentage, setPercentage] = useState(0);
  const [date, setDate] = useState();
  const [missingTopics, setMissingTopics] = useState([]);
  const [testname, setTestname] = useState("");
  const [name, setname] = useState("");
  const [missing_topics, setMissing_topics] = useState([]);
  const [newmissing_topics, setnewMissing_topics] = useState([]);
  const navigate = useNavigate();

  const [eng, seteng] = useState(0);
  const [math, setmath] = useState(0);

  const [quizmode, setquizmode] = useState(false);
  const maxScore = 1600;

  const [correctRate, setCorrectRate] = useState("");
  const [incorrectRate, setIncorrectRate] = useState("");
  const [markedRate, setMarkedRate] = useState("");
  const [omittedRate, setOmittedRate] = useState("");
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [topic, settopic] = useState(false);
  const [section, setsection] = useState("");

  const [apmcq, setapmcq] = useState(0);
  const [apfrq, setapfrq] = useState(0);

  const [mcqsubjects, setmcqsubjects] = useState([
    {
      main: "Concept of a Limit", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U1_1', name: '1.1 Introducing Calculus: Can Change Occur at an Instant?', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_2', name: '1.2 Defining Limits and Using Limit Notation', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_3', name: '1.3 Estimating Limit Values from Graphs', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_4', name: '1.4 Estimating Limit Values from Tables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_5', name: '1.5 Determining Limits Using Algebraic Properties of Limits', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_6', name: '1.6 Determining Limits Using Algebraic Manipulation', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_7', name: '1.7 Selecting Procedures for Determining Limits', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_8', name: '1.8 Determining Limits Using the Squeeze Theorem', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_9', name: '1.9 Connecting Multiple Representations of Limits', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Continuity", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U1_10', name: '1.10 Exploring Types of Discontinuities', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_11', name: '1.11 Defining Continuity at a Point', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_12', name: '1.12 Confirming Continuity over an Interval', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_13', name: '1.13 Removing Discontinuities', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Asymptotes & IVT", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U1_14', name: '1.14 Connecting Infinite Limits and Vertical Asymptotes', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_15', name: '1.15 Connecting Limits at Infinity and Horizontal Asymptotes', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U1_16', name: '1.16 Working with the Intermediate Value Theorem (IVT)', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Definition and Existence of Derivatives", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U2_1', name: '2.1 Defining Average and Instantaneous Rates of Change at a Point', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U2_2', name: '2.2 Defining the Derivative of a Function and Using Derivative Notation', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U2_3', name: '2.3 Estimating Derivatives of a Function at a Point', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U2_4', name: '2.4 Connecting Differentiability and Continuity: Determining When Derivatives Do and Do Not Exist', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Calculating Derivatives", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U2_5', name: '2.5 Applying the Power Rule', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U2_6', name: '2.6 Derivative Rules: Constant, Sum, Difference, and Constant Multiple', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U2_7', name: '2.7 Derivatives of cos(x), sin(x), mathrm, and ln(x)', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U2_8', name: '2.8 The Product Rule', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U2_9', name: '2.9 The Quotient Rule', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U2_10', name: '2.10 Finding the Derivatives of Tangent, Cotangent, Secant, and/or Cosecant Functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Advanced Derivative Rules", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U3_1', name: '3.1 The Chain Rule', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U3_2', name: '3.2 Implicit Differentiation', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Inverse Functions and Higher-Order Derivatives", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U3_3', name: '3.3 Differentiating Inverse Functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U3_4', name: '3.4 Differentiating Inverse Trigonometric Functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U3_5', name: '3.5 Selecting Procedures for Calculating Derivatives', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U3_6', name: '3.6 Calculating HigherOrder Derivatives', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Derivatives in Context", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U4_1', name: '4.1 Interpreting the Meaning of the Derivative in Context', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U4_2', name: '4.2 Straight-Line Motion: Connecting Position, Velocity, and Acceleration', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U4_3', name: '4.3 Rates of Change in Applied Contexts Other Than Motion', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Related Rates", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U4_4', name: '4.4 Introduction to Related Rates', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U4_5', name: '4.5 Solving Related Rates Problems', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Linearity and L'Hospital's Rule", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U4_6', name: '4.6 Approximating Values of a Function Using Local Linearity and Linearization', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U4_7', name: '4.7 Using LHospitals Rule for Determining Limits of Indeterminate Forms', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "MVT and EVT", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U5_1', name: '5.1 Using the Mean Value Theorem', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_2', name: '5.2 Extreme Value Theorem, Global Versus Local Extrema, and Critical Points', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Function Behavior", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U5_3', name: '5.3 Determining Intervals on Which a Function Is Increasing or Decreasing', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_4', name: '5.4 Using the First Derivative Test to Determine Relative (Local) Extrema', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_5', name: '5.5 Using the Candidates Test to Determine Absolute (Global) Extrema', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_6', name: '5.6 Determining Concavity of Functions over Their Domains', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_7', name: '5.7 Using the Second Derivative Test to Determine Extrema', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_8', name: '5.8 Sketching Graphs of Functions and Their Derivatives', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_9', name: '5.9 Connecting a Function, Its First Derivative, and Its Second Derivative', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Optimization", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U5_10', name: '5.10 Introduction to Optimization Problems', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_11', name: '5.11 Solving Optimization Problems', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U5_12', name: '5.12 Exploring Behaviors of Implicit Relations', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Concept of Integration", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U6_1', name: '6.1 Exploring Accumulations of Change', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_2', name: '6.2 Approximating Areas with Riemann Sums', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_3', name: '6.3 Riemann Sums, Summation Notation, and Definite Integral Notation', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Fundamental Theorem of Calculus", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U6_4', name: '6.4 The Fundamental Theorem of Calculus and Accumulation Functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_5', name: '6.5 Interpreting the Behavior of Accumulation Functions Involving Area', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_6', name: '6.6 Applying Properties of Definite Integrals', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_7', name: '6.7 The Fundamental Theorem of Calculus and Definite Integrals', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_8', name: '6.8 Finding Antiderivatives and Indefinite Integrals: Basic Rules and Notation', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Integration Techniques", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U6_9', name: '6.9 Integrating Using Substitution', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_10', name: '6.10 Integrating Functions Using Long Division and Completing the Square', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_11', name: '6.11 Integrating Using Integration by Parts', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_12', name: '6.12 Using Linear Partial Fractions ', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_13', name: '6.13 Evaluating Improper Integrals', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U6_14', name: '6.14 Selecting Techniques for Antidifferentiation', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Analyzing Differential Equations", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U7_1', name: '7.1 Modeling Situations with Differential Equations', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U7_2', name: '7.2 Verifying Solutions for Differential Equations', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U7_3', name: '7.3 Sketching Slope Fields', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U7_4', name: '7.4 Reasoning Using Slope Fields', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Solving Differential Equations", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U7_5', name: '7.5 Approximating Solutions Using Eulers Method', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U7_6', name: '7.6 Finding General Solutions Using Separation of Variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U7_7', name: '7.7 Finding Particular Solutions Using Initial Conditions and Separation of Variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Modeling Differential Equations", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U7_8', name: '7.8 Exponential Models with Differential Equations', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Solving Differential Equations", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U7_9', name: '7.9 Logistic Models with Differential Equations', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Definite Integrals in Context", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U8_1', name: '8.1 Finding the Average Value of a Function on an Interval', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_2', name: '8.2 Connecting Position, Velocity, and Acceleration of Functions Using Integrals', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_3', name: '8.3 Using Accumulation Functions and Definite Integrals in Applied Contexts', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Area Between Curves", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U8_4', name: '8.4 Finding the Area Between Curves Expressed as Functions of x', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_5', name: '8.5 Finding the Area Between Curves Expressed as Functions of y', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_6', name: '8.6 Finding the Area Between Curves That Intersect at More Than Two Points', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Volume", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U8_7', name: '8.7 Volumes with Cross Sections: Squares and Rectangles', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_8', name: '8.8 Volumes with Cross Sections: Triangles and Semicircles', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_9', name: '8.9 Volume with Disc Method: Revolving Around the x-or y-Axis', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_10', name: '8.10 Volume with Disc Method: Revolving Around Other Axes', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_11', name: '8.11 Volume with Washer Method: Revolving Around the x - or y-Axis', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U8_12', name: '8.12 Volume with Washer Method: Revolving Around Other Axes', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Arc Length", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U8_13', name: '8.13 The Arc Length of a Smooth, Planar Curve and Distance Traveled', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Parametric Equations", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U9_1', name: '9.1 Defining and Differentiating Parametric Equations', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U9_2', name: '9.2 Second Derivatives of Parametric Equations', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U9_3', name: '9.3 Finding Arc Lengths of Curves Given by Parametric Equations', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Vector-Valued Functions", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U9_4', name: '9.4 Defining and Differentiating VectorValued Functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U9_5', name: '9.5 Integrating VectorValued Functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U9_6', name: '9.6 Solving Motion Problems Using Parametric and VectorValued Functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Polar Coordinates", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U9_7', name: '9.7 Defining Polar Coordinates and Differentiating in Polar Form', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U9_8', name: '9.8 Find the Area of a Polar Region or the Area Bounded by a Single Polar Curve', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U9_9', name: '9.9 Finding the Area of the Region Bounded by Two Polar Curves', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Infinite Series", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U10_1', name: '10.1 Defining Convergent and Divergent Infinite Series', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_2', name: '10.2 Working with Geometric Series', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Tests for Convergence and Divergence", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U10_3', name: '10.3 The nth Term Test for Divergence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_4', name: '10.4 Integral Test for Convergence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_5', name: '10.5 Harmonic Series and p-Series', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_6', name: '10.6 Comparison Tests for Convergence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_7', name: '10.7 Alternating Series Test for Convergence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_8', name: '10.8 Ratio Test for Convergence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      main: "Sum of Series", count: 0, isOpen: true, isSelected: false, tag: 'mcq',
      subtopics: [
        { id: 'APCALC_U10_9', name: '10.9 Determining Absolute or Conditional Convergence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_10', name: '10.10 Alternating Series Error Bound', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_11', name: '10.11 Finding Taylor Polynomial Approximations of Functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_12', name: '10.12 Lagrange Error Bound', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_13', name: '10.13 Radius and Interval of Convergence of Power Series', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_14', name: '10.14 Finding Taylor or Maclaurin Series for a Function', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { id: 'APCALC_U10_15', name: '10.15 Representing Functions as Power Series', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
  ]);

  const [topics, settopics] = useState([
    { topic: "POW", full: "Production of Wirting" },
    { topic: "KLA", full: "knowledge of Language" },
    { topic: "CSE", full: "Conventions of Standard English" },

    { topic: "IES", full: "Intergrating Essential Skills" },
    { topic: "S", full: "Statistics and Probability" },
    { topic: "A", full: "Algebra" },
    { topic: "G", full: "Geometry" },
    { topic: "F", full: "Functions" },
    { topic: "N", full: "Number and Quantity" },
    { topic: "T", full: "Trigonometry" },

    { topic: "CS", full: "Craft and Structure" },
    { topic: "KID", full: "Key Ideas and Details" },
    { topic: "IKI", full: "Integration of Knowledge and Ideas" },

    { topic: "IOD", full: "Interpretation of Data" },
    { topic: "SIN", full: "Scientific Investigation" },
    { topic: "EMI", full: "Evaluation Models, Inferences, and Exprimental Results" }
  ]);

  useEffect(() => {
    if (missing_topics && missing_topics.length > 0) {
      getSimilarTopics();
    }
  }, [missing_topics]);

  function calculateRate(questionIds, total) {
    if (total === 0) return "0%"; // Avoid division by zero
    const rate = (questionIds.length / total) * 100;

    return `${Math.min(rate, 100).toFixed(0)}%`; // Cap the rate at 100% and format it
  }


  async function sendResult(data) {
    try {
      var eng_incorrect_questionIds = data.eng_incorrect_questionIds ? JSON.parse(data.eng_incorrect_questionIds) : [];
      if (data.section_data !== null) {

        var Correct_questionIds = data.Correct_questionIds ? safeParseJSON(data.Correct_questionIds) : [];
        var Incorrect_questionIds = data.Incorrect_questionIds ? safeParseJSON(data.Incorrect_questionIds) : [];
        var Marked_questionIds = data.Marked_questionIds ? safeParseJSON(data.Marked_questionIds) : [];
        var Omitted_questionIds = data.Omitted_questionIds ? safeParseJSON(data.Omitted_questionIds) : [];

        if (testData.type !== 'AP_Calc_AB') {
          setCorrectRate(calculateRate(Correct_questionIds, 98));
          setIncorrectRate(calculateRate(Incorrect_questionIds, 98));
          setMarkedRate(calculateRate(Marked_questionIds, 98));
          setOmittedRate(calculateRate(Omitted_questionIds, 98));
        } else {
          const mcqItems = Correct_questionIds.filter(item => item.section === 'mcq');
          setapmcq(mcqItems);

          const frqItems = Correct_questionIds.filter(item => item.section === 'frq');
          setapfrq(frqItems);

          setCorrectRate(calculateRate(Correct_questionIds, 51));
          setIncorrectRate(calculateRate(Incorrect_questionIds, 51));
          setMarkedRate(calculateRate(Marked_questionIds, 51));
          setOmittedRate(calculateRate(Omitted_questionIds, 51));
        }

        if (testData != {} && testData.quiz_data !== null) {
          if (testData.test_name !== "Free SAT") {
            setquizmode(true);
          }
        }

        seteng(data.eng_score);
        setmath(data.math_score);
        let newPercentage = Number(data.eng_score) + Number(data.math_score);
        setPercentage(newPercentage);

        var sat = data.section_data ? safeParseJSON(data.section_data) : [];
        let incorrectTopics = sat.filter(s => !s.correct).map(s => s.topic);
        let uniqueIncorrectTopics = [...new Set(incorrectTopics)];
        setMissingTopics([...uniqueIncorrectTopics]);
      } else {

        var length = JSON.parse(data.quiz_data).length;
        var eng_score = Math.round((JSON.parse(data.Correct_questionIds).length / length) * 100);

        setPercentage(eng_score);
        setquizmode(true);
      }

      let dateObj = new Date(data.date);
      let formattedDate = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
      setDate(formattedDate);
      setname(data.user_name);

      setTestname(testData.test_name);
      if (eng_incorrect_questionIds.length > 0) {
        setMissing_topics([...eng_incorrect_questionIds]);
      } else {
        let inc = JSON.parse(data.Incorrect_questionIds);
        const uniqueTopics = extractUniqueTopics(inc, data.type);
        setnewMissing_topics([...uniqueTopics]);
      }
    } catch (error) { }
  }

  function safeParseJSON(jsonString) {
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      console.error("Invalid JSON:", jsonString, error.message);
      return []; // Return an empty array or handle the error appropriately
    }
  }


  function extractUniqueTopics(questions, type) {
    const uniqueEntries = new Set(); // Use a Set to avoid duplicates
    const topicsWithTags = []; // To store the unique tag-topic pairs

    if (type === 'ACT') {
      questions.forEach(question => {
        const entry = `${question.type}-${question.category}`; // Combine tag and topic
        if (!uniqueEntries.has(entry)) {
          uniqueEntries.add(entry);
          topicsWithTags.push({ type: question.type, category: question.category });
        }
      });

    }
    else if (type === 'AP_Calc_AB') {
      questions.forEach(question => {
        const entry = `${question.type}-${question.topic[0]}`; // Combine tag and topic
        if (!uniqueEntries.has(entry)) {
          uniqueEntries.add(entry);
          topicsWithTags.push({ type: question.type, category: question.topic[0] });
        }
      });

    }
    else {
      questions.forEach(question => {
        const entry = `${question.tag}-${question.topic}`; // Combine tag and topic
        if (!uniqueEntries.has(entry)) {
          uniqueEntries.add(entry);
          topicsWithTags.push({ tag: question.tag, topic: question.topic });
        }
      });
    }

    return topicsWithTags; // Return array of unique tag-topic pairs
  }


  useEffect(() => {
    if (testData && testData.user_id != null) {
      if (!free) {
        sendResult(testData);
      } else {

        if (testData.section_data !== null) {
          const totalScore = parseInt(testData.eng_score, 10) + parseInt(testData.math_score, 10);
          setPercentage(totalScore);
          seteng(testData.eng_score);
          setmath(testData.math_score);
          if (testData.type !== 'AP_Calc_AB') {
            setquizmode(true);
          };
        } else {
          setquizmode(false);
          if (testData && testData.questions) {
            setquizmode(false);
            const totalQuestions = testData.questions.length;
            const correctAnswers = testData.questions.filter(question => question.correct).length;
            const percentage = Math.round((correctAnswers / totalQuestions) * 100);
            setPercentage(percentage);
          }
        }
      }
    }
  }, [testData])

  async function getSimilarTopics() {

    try {
      var res;
      if (testname.includes("89")) {
        res = await axios.get(BASELINE + "topics/89", { params: { itemIds: missing_topics } });
      }
      else if (testname.includes("10")) {
        res = await axios.get(BASELINE + "topics/10", { params: { itemIds: missing_topics } });
      }
      else {
        res = await axios.get(BASELINE + "topics", { params: { itemIds: missing_topics } });
      }
      let uniqueData = [...new Set(res.data)];
      setMissingTopics([...uniqueData]);

    } catch (err) {
    }

  }
  const capitalizeFirstLetter = (section) => {
    if (!section) return '';  // Check if section is empty or undefined
    return section.charAt(0).toUpperCase() + section.slice(1).toLowerCase();
  }
  const handleRowClick = (subjectName, section) => {
    if (section === 'eng') {
      setsection("English");
    } else if (section === 'ACT') {
      setsection("ACT");
    } else {
      setsection(capitalizeFirstLetter(section));
    }
    settopic(subjectName);
    setIsModalOpen2(true);
    // You can perform any actions here, such as navigation or displaying details
  };

  const ScoreArc = ({ score, max }) => {
    const r = 56, cx = 70, cy = 70;
    const circ = 2 * Math.PI * r;
    const arcLen = circ * 0.75;
    const filled = Math.min((parseFloat(score) || 0) / max, 1) * arcLen;
    return (
      <div className="relative mx-auto flex-shrink-0" style={{ width: 150, height: 150 }}>
        <svg width="150" height="150" viewBox="0 0 140 140">
          <defs>
            <linearGradient id="arcGrad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#3b82f6" />
              <stop offset="100%" stopColor="#6366f1" />
            </linearGradient>
          </defs>
          <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(0,0,0,0.07)" strokeWidth="10"
            strokeDasharray={`${arcLen} ${circ}`} strokeLinecap="round" transform={`rotate(135 ${cx} ${cy})`} />
          <circle cx={cx} cy={cy} r={r} fill="none" stroke="url(#arcGrad)" strokeWidth="10"
            strokeDasharray={`${filled} ${circ}`} strokeLinecap="round" transform={`rotate(135 ${cx} ${cy})`} />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-xl font-bold text-slate-800 tabular-nums leading-none">{score}</span>
          <span className="text-[10px] text-slate-400 font-medium mt-0.5">/ {max}</span>
        </div>
      </div>
    );
  };

  const SectionBar = ({ label, score, max, accentFrom, accentTo }) => {
    const pct = Math.min(((parseFloat(score) || 0) / max) * 100, 100);
    return (
      <div className="flex-1 bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm">
        <div className="h-1 w-full" style={{ background: `linear-gradient(to right, ${accentFrom}, ${accentTo})` }} />
        <div className="p-5">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">{label}</p>
          <p className="text-5xl font-black tabular-nums leading-none mb-1"
            style={{ background: `linear-gradient(135deg, ${accentFrom}, ${accentTo})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
            {score || '—'}
          </p>
          <p className="text-slate-400 text-xs mb-4">out of {max}</p>
          <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden mb-1.5">
            <div className="h-full rounded-full transition-all duration-700"
              style={{ width: `${pct}%`, background: `linear-gradient(to right, ${accentFrom}, ${accentTo})` }} />
          </div>
          <div className="flex justify-between text-[10px] text-slate-400">
            <span>Section Score</span>
            <span className="font-bold text-slate-600 tabular-nums">{Math.round(pct)}%</span>
          </div>
        </div>
      </div>
    );
  };

  const MetricCard = ({ label, value, icon: Icon, bg, border, iconColor, valueColor }) => (
    <div className={`${bg} ${border} border rounded-2xl p-4 flex flex-col gap-2 shadow-sm`}>
      <div className="flex items-center gap-2">
        <Icon className={`text-base ${iconColor}`} />
        <span className="text-[11px] font-bold text-slate-500 uppercase tracking-wide">{label}</span>
      </div>
      <p className={`text-3xl font-black tabular-nums ${valueColor}`}>{value || '—'}</p>
    </div>
  );

  const scoreDisplay = testData.type === 'AP_Calc_AB'
    ? quizmode ? `${percentage}%` : (testData.eng_score && JSON.parse(testData.eng_score)?.APscore ? JSON.parse(testData.eng_score).APscore : 'N/A')
    : quizmode ? `${percentage}%` : percentage;

  const maxDisplay = testData.type === 'AP_Calc_AB' ? (quizmode ? 100 : 5) : (quizmode ? 100 : 1600);

  const topicRow = (key, label, onClick) => (
    <button
      key={key}
      onClick={onClick}
      className="w-full text-left flex items-center gap-3 px-4 py-3 rounded-xl bg-rose-50 hover:bg-rose-100 border border-rose-100 hover:border-rose-300 transition-all duration-150 group"
    >
      <FaTimesCircle className="text-rose-400 text-sm flex-shrink-0" />
      <span className="text-sm text-slate-700 group-hover:text-slate-900 transition-colors flex-1 font-medium">{label}</span>
      <FaAnglesRight className="text-xs text-rose-300 group-hover:text-rose-500 transition-colors flex-shrink-0" />
    </button>
  );

  return (<>
    <ModalComponent topic={topic} isOpen={isModalOpen2} onClose={setIsModalOpen2} section={section} type={testData?.type} />

    <div className="min-h-screen bg-slate-50">
      {/* Sticky nav */}
      <div className="sticky top-0 z-10 bg-white border-b border-slate-200 px-6 py-3 flex items-center justify-between shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-1 h-5 rounded-full bg-gradient-to-b from-blue-500 to-indigo-500" />
          <span className="text-sm font-bold text-slate-700">Score Report</span>
        </div>
        <button
          onClick={() => navigate("/dashboard")}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200 border border-slate-200 transition-all duration-200"
        >
          Dashboard <FaAnglesRight className="text-xs" />
        </button>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 pb-16">

        {/* Page header */}
        <div className="mb-6">
          <div className="flex items-center gap-2 flex-wrap mb-2">
            <span className="text-xs font-bold px-2.5 py-1 rounded-full bg-blue-50 border border-blue-200 text-blue-600">
              {free ? 'Free Trial' : testname}
            </span>
            {name && <span className="text-xs text-slate-400 font-medium">{name}</span>}
            {date && <span className="text-xs text-slate-400">· {date}</span>}
          </div>
          <h1 className="text-2xl font-black text-slate-800">
            {user ? `${user.first_name}'s Score Report` : 'Score Report'}
          </h1>
        </div>

        {/* Hero: Score */}
        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 mb-4 shadow-sm overflow-hidden relative">
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 to-indigo-500" />
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-5">
            {testData.type === 'AP_Calc_AB' ? 'AP Exam Score' : quizmode ? 'Quiz Score' : 'Total SAT Score'}
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-8">
            <ScoreArc score={scoreDisplay} max={maxDisplay} />

            <div className="flex-1 text-center sm:text-left">
              <p className="text-7xl sm:text-8xl font-black tabular-nums leading-none"
                style={{ background: 'linear-gradient(135deg, #3b82f6, #6366f1)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                {scoreDisplay}
              </p>
              <p className="text-slate-400 text-sm mt-2">
                out of {testData.type === 'AP_Calc_AB' ? (quizmode ? '100' : '5') : quizmode ? '100' : '1,600'}
              </p>

              {quizmode === false && testData.type !== 'AP_Calc_AB' && (
                <div className="mt-5 max-w-xs">
                  <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                    <div className="h-full rounded-full transition-all duration-700"
                      style={{ width: `${Math.min((percentage / 1600) * 100, 100)}%`, background: 'linear-gradient(to right, #3b82f6, #6366f1)' }} />
                  </div>
                  <p className="text-[11px] text-slate-400 mt-1.5">
                    <span className="font-bold text-slate-600">{Math.round((percentage / 1600) * 100)}%</span> of maximum score
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Section breakdown */}
        {quizmode === false && (
          <div className="mb-4">
            {testData.type === 'AP_Calc_AB' ? (
              <div className="flex flex-col sm:flex-row gap-3">
                <SectionBar label="Multiple Choice" score={eng && JSON.parse(eng).mcq !== undefined ? Math.round(JSON.parse(eng).mcq) : 0} max={45} accentFrom="#3b82f6" accentTo="#818cf8" />
                <SectionBar label="Free Response" score={eng && JSON.parse(eng).frq !== undefined ? Math.round(JSON.parse(eng).frq) : 0} max={6} accentFrom="#6366f1" accentTo="#a78bfa" />
              </div>
            ) : (
              <div className="flex flex-col sm:flex-row gap-3">
                <SectionBar label="Reading & Writing" score={eng || 0} max={800} accentFrom="#3b82f6" accentTo="#6366f1" />
                <SectionBar label="Math" score={math || 0} max={800} accentFrom="#6366f1" accentTo="#818cf8" />
              </div>
            )}
          </div>
        )}

        {testData.section_data !== null && testData.type === 'AP_Calc_AB' && (
          <div className="flex flex-col sm:flex-row gap-3 mb-4">
            <SectionBar label="MCQ Correct" score={apmcq.length} max={45} accentFrom="#3b82f6" accentTo="#818cf8" />
            <SectionBar label="FRQ Correct" score={apfrq.length} max={36} accentFrom="#6366f1" accentTo="#a78bfa" />
          </div>
        )}

        {/* Performance breakdown */}
        <div className="mb-4">
          <div className="mb-3">
            <p className="text-sm font-bold text-slate-700">Performance Breakdown</p>
            <p className="text-xs text-slate-400 mt-0.5">How your answers broke down across the test</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <MetricCard label="Correct"   value={correctRate}   icon={FaCheckCircle} bg="bg-emerald-50"  border="border-emerald-200" iconColor="text-emerald-500" valueColor="text-emerald-600" />
            <MetricCard label="Incorrect" value={incorrectRate} icon={FaTimesCircle}  bg="bg-rose-50"     border="border-rose-200"    iconColor="text-rose-500"    valueColor="text-rose-600" />
            <MetricCard label="Marked"    value={markedRate}    icon={FaBookmark}     bg="bg-amber-50"    border="border-amber-200"   iconColor="text-amber-500"   valueColor="text-amber-600" />
            <MetricCard label="Skipped"   value={omittedRate}   icon={FaMinus}        bg="bg-slate-50"    border="border-slate-200"   iconColor="text-slate-400"   valueColor="text-slate-500" />
          </div>
        </div>

        {/* Topics to review */}
        {(missing_topics.length > 0 || newmissing_topics.length > 0) && (
          <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
            <div className="flex items-start justify-between mb-5">
              <div>
                <p className="text-base font-bold text-slate-800">Topics to Review</p>
                <p className="text-xs text-slate-400 mt-0.5">Concepts from questions you answered incorrectly — click to practice</p>
              </div>
              <span className="flex-shrink-0 text-xs font-bold px-3 py-1.5 rounded-full bg-rose-50 border border-rose-200 text-rose-600 ml-4">
                {missing_topics.length + newmissing_topics.length} topics
              </span>
            </div>
            <div className="max-h-[420px] overflow-y-auto space-y-2" style={{ scrollbarWidth: 'thin', scrollbarColor: '#e2e8f0 transparent' }}>
              {[...missing_topics].map((item, index) =>
                topicRow(`${item.tag}-${item.topic}-${index}`, item.topic, () => handleRowClick(item.topic, item.tag))
              )}
              {testData.type === 'AP_Calc_AB' ? (
                newmissing_topics.map((item, index) => {
                  const matchingSubtopic = mcqsubjects.reduce((found, topic) =>
                    found || topic.subtopics.find(subtopic => subtopic.id === item.category), null);
                  if (!matchingSubtopic) return null;
                  return topicRow(`${item.type}-${item.category}-${index}`, matchingSubtopic.name, () => handleRowClick(item.category, item.type));
                })
              ) : testData.type === 'ACT' ? (
                [...newmissing_topics].map((item, index) => {
                  let parsedCategory;
                  try { parsedCategory = JSON.parse(item.category); if (Array.isArray(parsedCategory)) parsedCategory = parsedCategory[0]; }
                  catch { parsedCategory = item.category; }
                  const matchingTopic = topics.find(t => t.topic.toUpperCase() === parsedCategory.toUpperCase());
                  return topicRow(`${parsedCategory}-${index}`, matchingTopic ? matchingTopic.full : parsedCategory, () => handleRowClick(item.category, item.type));
                })
              ) : (
                [...newmissing_topics].map((item, index) =>
                  topicRow(`${item.tag}-${item.topic}-${index}`, item.topic, () => handleRowClick(item.topic, item.tag))
                )
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  </>);
};

export default Hero;
